import script from "./footerNav.vue?vue&type=script&setup=true&name=footerNav&lang=js"
export * from "./footerNav.vue?vue&type=script&setup=true&name=footerNav&lang=js"

import "./footerNav.vue?vue&type=style&index=0&id=aba12fa0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aba12fa0"]])

export default __exports__